




























import Vue from "vue";
import SelectList from "@/components/shared/SelectList.vue";
import { Component, Prop } from "vue-property-decorator";
import {
  JinroPlayerDocument,
  JinroGameDocument,
  VoteDocument,
} from "@/services/datatypes";
import SelectResult from "@/components/shared/SelectResult.vue";
import { db, firestore } from "@/scripts/firebase";
import { collectionName } from "@/services/collection-name";

interface JinroSecretsDocument {
  votablePlayers: Array<JinroPlayerDocument>;
  votes: Array<VoteDocument>;
  timeCreated: any;
}

@Component({
  components: {
    SelectResult,
    SelectList,
  },
})
export default class Jinro extends Vue {
  @Prop() readonly jinroGameId!: string;
  detacher?: firebase.Unsubscribe;
  jinroSecrets: JinroSecretsDocument | null = null;

  created() {
    if (!this.$store.state.jinroGame) {
      return;
    }
    const jinroGameId = this.$store.state.jinroGame.id;
    const jinroPlayinfoId = this.$store.state.jinroGame.currentJinroPlayinfoId;
    this.detacher = db
      .collection(collectionName.jinrogames)
      .doc(jinroGameId)
      .collection(collectionName.jinroplayinfo)
      .doc(jinroPlayinfoId)
      .collection(collectionName.jinrosecrets)
      .doc(jinroPlayinfoId)
      .onSnapshot((snapshot) => {
        this.jinroSecrets = snapshot.data() as JinroSecretsDocument;
      });
  }
  destroyed() {
    this.detacher && this.detacher();
  }

  get votablePlayers(): Array<JinroPlayerDocument> {
    if (this.jinroSecrets) {
      return this.jinroSecrets.votablePlayers;
    } else {
      return [];
    }
  }

  get jinroGame(): JinroGameDocument | null {
    if (this.$store.state.jinroGame) {
      return this.$store.state.jinroGame;
    }
    return null;
  }
  get survivors(): Array<JinroPlayerDocument> {
    if (this.jinroGame) {
      return this.jinroGame.survivors;
    }
    return [];
  }

  get submittedPlayerName(): string {
    if (!this.votes) {
      return "";
    }
    const playerId = this.$route.params.jinroPlayerId;
    const submittedPlayer = this.votes.find((vote) => {
      return vote.fromPlayer.id === playerId;
    });
    if (!submittedPlayer) {
      return "";
    }
    return submittedPlayer.toPlayer.playerName;
  }

  get votes(): Array<VoteDocument> {
    if (!this.jinroSecrets) {
      return [];
    }
    if (!this.jinroSecrets.votes) {
      return [];
    }
    return this.jinroSecrets.votes;
  }

  get hasSubmited(): boolean {
    const me = this.votes.find((vote) => {
      return vote.fromPlayer.id === this.$route.params.jinroPlayerId;
    });
    return me ? true : false;
  }
  async handleCancelSubmit() {
    const votes = this.votes;
    const afterVotes = votes.filter((vote) => {
      return vote.fromPlayer.id !== this.$route.params.jinroPlayerId;
    });

    await this.refJinroSecret.set(
      {
        votes: afterVotes,
        timeUpdated: firestore.FieldValue.serverTimestamp(),
      },
      {
        merge: true,
      }
    );

    return;
  }

  async handleSubmit(selectedOption: string) {
    const players: Array<JinroPlayerDocument> = this.survivors;
    const fromPlayer = players.find((player) => {
      return player.id === this.$route.params.jinroPlayerId;
    });
    const toPlayer = players.find((player) => {
      return player.id === selectedOption;
    });

    if (!fromPlayer || !toPlayer) {
      return;
    }

    const newVote: VoteDocument = {
      fromPlayer: fromPlayer,
      toPlayer: toPlayer,
    };
    const afterVotes = this.votes.filter((vote) => {
      return vote.fromPlayer.id !== fromPlayer.id;
    });
    afterVotes.push(newVote);

    // update vote info to jinroplayinfo
    await this.refJinroSecret.set(
      {
        votes: afterVotes,
        timeUpdated: firestore.FieldValue.serverTimestamp(),
      },
      {
        merge: true,
      }
    );
  }

  get refJinroSecret(): firebase.firestore.DocumentReference {
    const jinroPlayinfoId = this.$store.state.jinroGame.currentJinroPlayinfoId;
    return db
      .collection(collectionName.jinrogames)
      .doc(this.jinroGameId)
      .collection(collectionName.jinroplayinfo)
      .doc(jinroPlayinfoId)
      .collection(collectionName.jinrosecrets)
      .doc(jinroPlayinfoId);
  }

  get selectLabel(): string {
    return "あなたは誰を襲いたいですか";
  }
}
